module.exports = __webpack_public_path__ + "img/user_profile_2.d4e8981d.png";